<template>
  <div>
    <div class="grid-container">
      <div class="grid-x legend-row">
        <div class="small-12 cell">
          <rare-graph-legend />
        </div>
      </div>
      <div class="grid-x graph-row">
        <div class="small-7 cell">
          <rare-single-metric-chart
            :chart-data="oneFlagApplications"
            :size="'large'"
            :title="'1+ Flag Applications'"
            :canvas-i-d="'summaryOneFlagApplications'"
          />
          <rare-control-pane
            :title="'Flag Category Breakdown'"
            :pane-to-control="'flagCatBreakdownPane'"
            @changePaneState="changePaneState"
          />
          <div
            v-if="paneStates.flagCatBreakdownPane"
            class="slideDown"
          >
            <div class="socioeconomicFlagPane">
              <rare-single-metric-chart
                :chart-data="socioeconomicFlag.categoryData"
                :size="'medium'"
                :title="'Socioeconomic Flag'"
                :canvas-i-d="'summarySocioeconomicFlag'"
              />
              <rare-control-pane
                :title="'Socioeconomic Breakdown'"
                :pane-to-control="'socioBreakdownPane'"
                @changePaneState="changePaneState"
              />
              <div
                v-if="paneStates.socioBreakdownPane"
                class="slideDown topSpacer"
              >
                <rare-single-metric-chart
                  :chart-data="socioeconomicFlag.firsGenUni"
                  :size="'small'"
                  :title="'First Generation at University'"
                  :canvas-i-d="'summarySocioeconomicFlagfirsGenUni'"
                />
                <rare-single-metric-chart
                  :chart-data="socioeconomicFlag.freeSchoolMeals"
                  :size="'small'"
                  :title="'Free School Meals'"
                  :canvas-i-d="'summarySocioeconomicFlagFreeSchoolMeals'"
                />
                <rare-single-metric-chart
                  :chart-data="socioeconomicFlag.postcode"
                  :size="'small'"
                  :title="'Disadvantaged Postcode'"
                  :canvas-i-d="'summarySocioeconomicFlagPostcode'"
                />
                <rare-single-metric-chart
                  :chart-data="socioeconomicFlag.uniWork"
                  :size="'small'"
                  :title="'University Term Work'"
                  :canvas-i-d="'summarySocioeconomicFlagUniWork'"
                />
                <rare-single-metric-chart
                  :chart-data="socioeconomicFlag.schoolWork"
                  :size="'small'"
                  :title="'School Term Work'"
                  :canvas-i-d="'summarySocioeconomicFlagSchoolWork'"
                />
              </div>
            </div>
            <div class="socioeconomicFlagPane">
              <rare-single-metric-chart
                :chart-data="academicFlag.categoryData"
                :size="'medium'"
                :title="'Academic Flags'"
                :canvas-i-d="'summaryAcademicFlag'"
              />
              <rare-control-pane
                :title="'Academic Flag Breakdown'"
                :pane-to-control="'academicBreakdownPane'"
                @changePaneState="changePaneState"
              />
              <div
                v-if="paneStates.academicBreakdownPane"
                class="slideDown topSpacer"
              >
                <rare-single-metric-chart
                  :chart-data="academicFlag.bottom40"
                  :size="'small'"
                  :title="'Attended Bottom 40% School'"
                  :canvas-i-d="'summaryAccademicBottom40'"
                />
                <rare-single-metric-chart
                  :chart-data="academicFlag.bottom10"
                  :size="'small'"
                  :title="'Attended Bottom 10% School'"
                  :canvas-i-d="'summaryAccademicBottom10'"
                />
              </div>
            </div>
            <div class="socioeconomicFlagPane">
              <rare-single-metric-chart
                :chart-data="personalFlag.categoryData"
                :size="'medium'"
                :title="'Personal Flags'"
                :canvas-i-d="'summaryPersonalFlag'"
              />
              <rare-control-pane
                :title="'Personal Flag Breakdown'"
                :pane-to-control="'personalBreakdownPane'"
                @changePaneState="changePaneState"
              />
              <div
                v-if="paneStates.personalBreakdownPane"
                class="slideDown topSpacer"
              >
                <rare-single-metric-chart
                  :chart-data="personalFlag.refugeeAsylum"
                  :size="'small'"
                  :title="'Refugee/ Asylum Seeker'"
                  :canvas-i-d="'summaryPersonalRefugee'"
                />
                <rare-single-metric-chart
                  :chart-data="personalFlag.inCare"
                  :size="'small'"
                  :title="'Spent Time In Care'"
                  :canvas-i-d="'summaryPersonalInCare'"
                />
                <rare-single-metric-chart
                  :chart-data="personalFlag.carerParent"
                  :size="'small'"
                  :title="'Carer/Parent'"
                  :canvas-i-d="'summaryPersonalParent'"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="small-1 cell">
&nbsp;
        </div>
        <div class="small-4 cell">
          <rare-flag-breakdown-chart
            :chart-data="flagBreakDownData"
            :canvas-i-d="'flagBreakDownChart'"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';

import RarePaneControl from '../../components/layout/RarePaneControl.vue';
import RareGraphLegend from '../../components/layout/RareGraphLegend.vue';
import RareSingleMetricChart from '../../components/charts/RareSingleMetricChart.vue';
import RareFlagBreakDownChart from '../../components/charts/RareFlagBreakDownChart.vue';

export default {
  name: 'ClientSummary',
  components: {
    'rare-graph-legend': RareGraphLegend,
    'rare-control-pane': RarePaneControl,
    'rare-single-metric-chart': RareSingleMetricChart,
    'rare-flag-breakdown-chart': RareFlagBreakDownChart,
  },
  data() {
    return {
      initialLoad: true,
      chartData: {},
      oneFlagApplications: [],
      socioeconomicFlag: {
        categoryData: [],
        firsGenUni: [],
        freeSchoolMeals: [],
        postcode: [],
        uniWork: [],
        schoolWork: [],
      },
      academicFlag: {
        categoryData: [],
        bottom40: [],
        bottom10: [],
      },
      personalFlag: {
        categoryData: [],
        refugeeAsylum: [],
        inCare: [],
        carerParent: [],
      },
      flagBreakDownData:
        [[0, 0, 0, 0, 0, 0],
          [0, 0, 0, 0, 0, 0],
          [0, 0, 0, 0, 0, 0],
          [0, 0, 0, 0, 0, 0]],
      paneStates: {
        flagCatBreakdownPane: false,
        socioBreakdownPane: false,
        academicBreakdownPane: false,
        personalBreakdownPane: false,
      },
    };
  },
  computed: {
    ...mapGetters({
      getSummaryCategoryData: '$_summary/getSummaryCategoryData',
      getSummaryFlagBreakDownData: '$_summary/getSummaryFlagBreakDownData',
      getSummaryOnePlusFlagData: '$_summary/getSummaryOnePlusFlagData',
      getSummarySingleMetricData: '$_summary/getSummarySingleMetricData',
      totalApplications: 'totalApplicationsBase',
      currentClient: 'currentClientDisplayName',
      dataFormat: 'dataFormat',
    }),
  },
  created() {
    this.$store.commit('updatePageTitle', this.$store.getters.currentClientDisplayName);
    this.$store.commit('updateShowLogoutIcon', true);
    this.$store.commit('updateShowDownloadIcon', true);
    this.$store.commit('updateShowNavigationLinks', true);
    this.$store.commit('updateShowControlPanel', true);
  },
  mounted() {
    this.track();
    document.title = `CRS Dashboard | ${this.$route.name}`;
    if (this.$store.getters.initialLoad('summary') === true
       || (this.$store.getters.summaryParamsExitHash !== this.$store.getters.currentParamsHash)) {
      this.updateSummaryCharts();
    } else {
      this.renderSummaryCharts();
    }

    this.$root.$on('updateClient', () => {
      this.clientChange();
    });
    this.$root.$on('updateCharts', () => {
      this.updateSummaryCharts();
    });
    this.$root.$on('renderCharts', () => {
      this.renderSummaryCharts();
    });
  },
  beforeDestroy() {
    this.$store.commit('updateInitialLoad', { page: 'summary', value: false });
    this.$store.commit('updateCurrentParamsHash', 'summaryParamsExitHash');
    this.$root.$off('updateClient');
    this.$root.$off('updateCharts');
    this.$root.$off('renderCharts');
  },
  methods: {
    track() {
      this.$gtag.pageview({
        page_path: `/summary/${this.currentClient === '' ? 'rare' : this.currentClient}`,
      });
    },
    changePaneState(paneData) {
      this.paneStates[paneData] = !this.paneStates[paneData];
    },
    clientChange() {
      this.$store.commit('updatePageTitle', this.$store.getters.currentClientDisplayName);
      this.updateSummaryCharts();
    },
    updateSummaryCharts() {
      this.$store.commit('updateSummaryLoadingState', 'loading');
      this.$store.dispatch('$_summary/updateSummaryCharts').then(() => {
        this.renderSummaryCharts();
        this.$store.commit('updateSummaryLoadingState', 'stopped');
      }, (error) => {
        // eslint-disable-next-line
        alert(`Looks like a error connecting to our database. Please
        refresh the page and try again. - ${error}`);
        return error;
      });
    },
    renderSummaryCharts() {
      this.flagBreakDownData = this.getSummaryFlagBreakDownData(
        {
          dataFormat: this.dataFormat,
        },
      );

      this.oneFlagApplications = this.getSummaryOnePlusFlagData(this.dataFormat);

      this.socioeconomicFlag.categoryData = this.getSummaryCategoryData(
        {
          type: 'Socioeconomic flags',
          dataFormat: this.dataFormat,
        },
      );
      this.socioeconomicFlag.firsGenUni = this.getSummarySingleMetricData(
        {
          type: 'First Gen',
          dataFormat: this.dataFormat,
        },
      );
      this.socioeconomicFlag.freeSchoolMeals = this.getSummarySingleMetricData(
        {
          type: 'FSM',
          dataFormat: this.dataFormat,
        },
      );
      this.socioeconomicFlag.postcode = this.getSummarySingleMetricData(
        {
          type: 'Disadvantaged postcode',
          dataFormat: this.dataFormat,
        },
      );
      this.socioeconomicFlag.uniWork = this.getSummarySingleMetricData(
        {
          type: 'Uni Term Work',
          dataFormat: this.dataFormat,
        },
      );
      this.socioeconomicFlag.schoolWork = this.getSummarySingleMetricData(
        {
          type: 'School Term Work',
          dataFormat: this.dataFormat,
        },
      );
      this.academicFlag.categoryData = this.getSummaryCategoryData(
        {
          type: 'Academic flags',
          dataFormat: this.dataFormat,
        },
      );
      this.academicFlag.bottom40 = this.getSummarySingleMetricData(
        {
          type: 'Bottom 40% school',
          dataFormat: this.dataFormat,
        },
      );
      this.academicFlag.bottom10 = this.getSummarySingleMetricData(
        {
          type: 'Bottom 10% school',
          dataFormat: this.dataFormat,
        },
      );

      this.personalFlag.categoryData = this.getSummaryCategoryData(
        {
          type: 'Personal flags',
          dataFormat: this.dataFormat,
        },
      );
      this.personalFlag.refugeeAsylum = this.getSummarySingleMetricData(
        {
          type: 'Refugee/Asylum seeker',
          dataFormat: this.dataFormat,
        },
      );
      this.personalFlag.inCare = this.getSummarySingleMetricData(
        {
          type: 'In care',
          dataFormat: this.dataFormat,
        },
      );
      this.personalFlag.carerParent = this.getSummarySingleMetricData(
        {
          type: 'Carer/Parent',
          dataFormat: this.dataFormat,
        },
      );
    },
  },
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  .graph-row {
    margin-top: 35px;
  }

  .topSpacer {
    margin-top: 25px;
    margin-bottom: 40px;
    padding-bottom: 25px;
    border-bottom: solid 1px #b4bfc8;
  }

</style>
